import React, { useEffect, useState } from "react";
import ToastrMessage from "../../js/toastrMessage";
import axios from "axios";
import { Link } from "react-router-dom";
import $ from "jquery";
import ReactPaginate from "react-paginate";

const WNLawTeams = () => {
  const [userID, setUserID] = useState("");
  const [users, setUsers] = useState([]);
  const [role, setRole] = useState([]);
  const [usersIdToDelete, setusersIdToDelete] = useState(null);
  const API_URL = process.env.REACT_APP_API_BASE_URL;
  const [pageNumber, setPageNumber] = useState(0);
  const itemsPerPage = 5;
  const pageCount = Math.ceil(users.length / itemsPerPage);
  const startIndex = pageNumber * itemsPerPage;
  const displayedItems = users.slice(startIndex, startIndex + itemsPerPage);

  const getUserIdFromLocalStorage = async () => {
    try {
      const user = localStorage.getItem("user");

      if (user) {
        const userData = JSON.parse(user);
        setUserID(userData.user.id);
      }
    } catch (error) {
      // console.log("Error fetching userID : ", error);
    }
  };

  const getUserRoleById = async (setRole) => {
    try {
      const response = await axios.get(`${API_URL}/users/${userID}`);

      setRole(response.data.role);
    } catch (error) {
      // console.log("Error fetching profile : ", error);
    }
  };

  const getUsers = async (setUsers) => {
    try {
      const response = await axios.get(`${API_URL}/users`);
      setUsers(response.data);
      // console.log("success fetching users");
    } catch (error) {
      console.log("Error fetching users : ", error);
    }
  };

  const deleteTeams = async (usersId) => {
    try {
      await axios.delete(`${API_URL}/users/${usersId}`);
      getUsers(setUsers);
      // console.log("success deleting service: ");
    } catch (error) {
      // console.log("Error deleting service: ", error);
    }
  };

  const changePage = ({ selected }) => {
    setPageNumber(selected);
  };

  const handleConfirmDelete = () => {
    console.log("masuk");
    if (usersIdToDelete) {
      console.log("delete");
      deleteTeams(usersIdToDelete);
      setusersIdToDelete(null);
      $("#exampleModal").modal("hide");
    }
  };

  useEffect(() => {
    getUserIdFromLocalStorage();
  }, []);

  useEffect(() => {
    getUserRoleById(setRole);
    getUsers(setUsers);
    ToastrMessage();
  }, [userID]);

  return (
    <div className="main-content">
      <section className="section">
        <div className="section-header">
          <h1>Team</h1>
          <div class="section-header-breadcrumb">
            <div class="breadcrumb-item active">
              <a href="/dashboard/general">Dashboard</a>
            </div>
            <div class="breadcrumb-item">
              <a href="#">Document</a>
            </div>
            <div class="breadcrumb-item">Teams</div>
          </div>
        </div>

        <h2 className="section-title">Team Table</h2>
        <p className="section-lead">Our team detailed here.</p>
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div className="card-header d-flex justify-content-between align-items-center">
                <h4>Details</h4>
                {role && role === "Admin" && (
                  <div className="col-auto">
                    <Link
                      to="/form/add-teams"
                      className="btn btn-primary btn-lg d-flex align-items-center"
                      style={{ padding: "0.75rem" }}
                    >
                      <i className="fas fa-plus mr-2"></i>
                      Add Teams
                    </Link>
                  </div>
                )}
              </div>
              <div className="card-body p-0">
                <div className="table-responsive">
                  <table className="table table-striped">
                    <tr>
                      <th>No</th>
                      <th>Name</th>
                      <th>Description</th>
                      <th>Phone</th>
                      <th>Position</th>
                      {role && role === "Admin" && (
                        <th className="text-center col-2">Action</th>
                      )}
                    </tr>
                    <tbody>
                      {displayedItems.map((user, index) => (
                        <tr key={user.id}>
                          <th scope="row">{startIndex + index + 1}</th>
                          <td>
                            <Link
                              to={`/form/edit-teams/${user.id}`}
                              className="font-weight-600"
                            >
                              <div className="d-flex align-items-center">
                                <img
                                  src="../assets/img/avatar/avatar-1.png"
                                  alt="avatar"
                                  width="30"
                                  className="rounded-circle mr-3"
                                />
                                <div>
                                  <p className="font-weight-600 m-0">
                                    {user.firstname} {user.lastname}
                                  </p>
                                </div>
                              </div>
                            </Link>
                          </td>
                          <td>
                            {user.desc.length > 300
                              ? `${user.desc.substring(0, 300)}...`
                              : user.desc}
                            <div className="table-links">
                              in <a href="https://wnlaw.net/">{user.office}</a>
                              <div className="bullet"></div>
                              {/* <a href="#">View</a> */}
                            </div>
                          </td>
                          <td>
                            <p className="font-weight-600">{user.phone}</p>
                          </td>
                          <td>
                            <p className="font-weight-600">{user.position}</p>
                          </td>
                          {role && role === "Admin" && (
                            <td className="text-center">
                              <Link
                                to={`/form/edit-teams/${user.id}`}
                                className="btn btn-primary btn-action mr-1"
                                data-toggle="tooltip"
                                title="Edit"
                              >
                                <i className="fas fa-pencil-alt"></i>
                              </Link>
                              <button
                                className="btn btn-danger"
                                onClick={() => {
                                  setusersIdToDelete(user.id);
                                  console.log(user);
                                  $("#exampleModal").modal("show");
                                }}
                              >
                                <i className="fas fa-trash"></i>
                              </button>
                            </td>
                          )}
                        </tr>
                      ))}
                      {/* <tr>
                          <th scope="row">2</th>
                          <td>
                            <a href="#" className="font-weight-600">
                              <img
                                src="../assets/img/avatar/avatar-1.png"
                                alt="avatar"
                                width="30"
                                className="rounded-circle mr-1"
                              />{" "}
                              Administrator
                            </a>
                          </td>
                          <td>
                            Introduction Laravel 5
                            <div className="table-links">
                              in <a href="#">Web Development</a>
                              <div className="bullet"></div>
                              <a href="#">View</a>
                            </div>
                          </td>
                          <td>
                            <p className="font-weight-600">Kepala Lawyer</p>
                          </td>
                          <td>
                            <a
                              className="btn btn-primary btn-action mr-1"
                              data-toggle="tooltip"
                              title="Edit"
                            >
                              <i className="fas fa-pencil-alt"></i>
                            </a>
                            <a
                              className="btn btn-danger btn-action"
                              data-toggle="tooltip"
                              title="Delete"
                              data-confirm="Are You Sure?|This action can not be undone. Do you want to continue?"
                            >
                              <i className="fas fa-trash"></i>
                            </a>
                          </td>
                        </tr> */}
                    </tbody>
                  </table>
                </div>
              </div>
              <ReactPaginate
                previousLabel={"Previous"}
                nextLabel={"Next"}
                pageCount={pageCount}
                onPageChange={changePage}
                containerClassName={
                  "pagination justify-content ml-3 mt-4 mr-5 mb-4"
                }
                previousLinkClassName={"page-link"}
                nextLinkClassName={"page-link"}
                disabledClassName={"page-item disabled"}
                activeClassName={"page-item active"}
                pageClassName={"page-item"}
                pageLinkClassName={"page-link"}
              />
            </div>
          </div>
        </div>
      </section>
      {/* Modal for confirmation */}
      <div className="modal fade" tabIndex="-1" role="dialog" id="exampleModal">
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Delete</h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <p>
                Do you really want to delete this item?{" "}
                <b>This action cannot be undone</b>.
              </p>
            </div>
            <div className="modal-footer bg-whitesmoke br">
              <button
                type="button"
                className="btn btn-danger btn-shadow"
                onClick={handleConfirmDelete}
                id="toastr-10"
              >
                Yes
              </button>
              <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
              >
                No
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WNLawTeams;
